import { Component } from "react";

// Prinde erorile de randare din orice pagină, ca un throw dintr-un singur
// ecran să nu lase tot SPA-ul alb. Afișează un mesaj prietenos în română.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Log discret pentru diagnostic (nu blochează UI-ul de fallback)
    try {
      // eslint-disable-next-line no-console
      console.error("ErrorBoundary a prins o eroare:", error, info);
    } catch (_) { /* noop */ }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            padding: "2rem",
            gap: "1rem",
            background: "var(--ct-bg, #fbfaf7)",
            color: "var(--ct-text, #1c1c1c)",
          }}
          data-testid="error-boundary"
        >
          <h1 style={{ fontSize: "1.75rem", fontFamily: "serif", margin: 0 }}>
            A apărut o eroare.
          </h1>
          <p style={{ color: "var(--ct-text-muted, #666)", maxWidth: "28rem" }}>
            Ceva nu a mers cum trebuie. Reîncarcă pagina — de obicei se rezolvă.
          </p>
          <div style={{ display: "flex", gap: "0.75rem", flexWrap: "wrap", justifyContent: "center" }}>
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="btn-gold"
              data-testid="error-reload"
            >
              Reîncarcă pagina
            </button>
            <a href="/" className="btn-outline-gold" data-testid="error-home">
              Mergi la Acasă
            </a>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
